import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const SrpPriceCheckerThankYouViewAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "srp-price-checker-thank-you-view" */ './srp-price-checker-thank-you-view'),
  componentName: 'SrpPriceCheckerThankYouView',
});
